<template lang="pug">
  div
    .c-list-title
      span Customers
      br
      .row
        input(type="text"
        class="Typeahead__input"
        placeholder="Search Customer..."
        autocomplete="off"
        v-model="query"
        ref="input"
        spellcheck="false"
        v-debounce:40ms.lock="autoCompleteFunc" :debounce-events="'input'")
        .clean-customer(@click="cleanCustomer" v-if="!!selectedCustomerIdDashboard")
          vm-icon(icon="close-outline")
    ul.c-list-cont(v-infinite-scroll="loadMore" :infinite-scroll-disabled="busy" infinite-scroll-distance="100")
      li.list-item(:key="item.id" v-for="(item, index) in customersDashboard" @click="handleClick(item, index)" :class="{ 'active': (activeIndex === index) && selectedCustomerIdDashboard }")
        .p-img-cont
          .logo(v-if="item.company_logo" :style="item.company_logo && `background: #fff url(${item.company_logo}) no-repeat center / cover`")
          .logo.no-logo(v-else)
            vm-icon(icon="image-outline" color="rgb(183, 183, 183)" size="1.5rem")
        .customer-name {{ item.name }}
      loader(v-if="loading")
</template>

<script>
import Loader from '@/components/aditionals/Loader.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')

export default {
  name: 'customer-infinite-list',
  components: {
    Loader
  },
  data: () => ({
    currentPage: 0,
    busy: false,
    loading: true,
    activeIndex: undefined,
    limit: 5,
    minChars: 3,
    items: [],
    query: '',
    current: -1,
    selectFirst: false
  }),
  props: {},
  methods: {
    ...mapActions([
      'loadCustomersDashboard',
      'loadCatalog'
    ]),
    async loadMore () {
      this.loading = true
      if (this.currentPage <= this.pagination.totalPages || this.currentPage === 1) {
        this.currentPage++
        await this.getCustomers(this.currentPage)
      }
      this.loading = false
    },
    async getCustomers (page) {
      await this.loadCustomersDashboard({ page })
    },
    handleClick (customer, index) {
      this.activeIndex = index
      this.$emit('click', customer)
    },
    cleanCustomer () {
      this.items = []
      this.query = ''
      this.loading = false
      this.$emit('click')
      this.autoCompleteFunc()
    },
    autoCompleteFunc () {
      this.loadCatalog({ filter: `?param=${this.query},name`, url: 'customers' })
    }
  },
  computed: {
    ...mapGetters([
      'customersDashboard',
      'pagination',
      'selectedCustomerIdDashboard',
      'dashboardCatalog'
    ])
  }
}
</script>

<style lang="scss" scoped>
.c-list-cont {
  width: 100%;
  background: white;
  border-radius: 10px;
  min-height: 50vh;
  max-height: calc(100vh - 430px);
  margin: 20px 10px 0px 0px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: content-box;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.c-list-title {
  top: 0;
  left: 0;
  z-index: 999;
  margin-right: 15px;
}
.clean-customer {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: gray;
  font-size: 0.6rem;
  margin-left: 5px;
}
ul {
  list-style-type: none;
}
.list-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: content-box;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border-left: 2px solid transparent;
}
.list-item:hover {
  background: #eeeeee;
}
.active {
  border-left: 2px solid #ED1B24;
  background: #eeeeee;
}
.p-img-cont {
  background: #ED1B24;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  flex-shrink: 0;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo {
    width: 80%;
    height: 80%;
    border: 2px solid white;
    background: #e4e4e4;
    border-radius: 50%;
    box-sizing: content-box;
  }
  .no-logo {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.customer-name {
  letter-spacing: -0.02rem;
  width: 100%;
  line-height: 1rem;
  font-size: 13px;
}
.fix-height {
  height: 41px;
}
button {
  border: 0 !important;
}

.Typeahead {
  margin-left: 15px;
}

.Typeahead__input {
 color: inherit;
  width: 100%;
  position: relative;
  padding: 7px;
  border-radius: 5px;
  border: 1px solid transparent;
  box-sizing: border-box;
  -webkit-box-shadow: 0 2px 8px 0 rgba(59,65,94,0.1), 0 1px 1px 0 rgba(0,0,0,0.07);
  box-shadow: 0 2px 8px 0 rgba(59,65,94,0.1), 0 1px 1px 0 rgba(0,0,0,0.07);
  transition: all .3s ease;
  width: 100%;
  padding-right: 25px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fa-times {
  cursor: pointer;
}
.row {
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
